import { createTokenHeader } from '../utils/functions/headers';
import {
  TCommission,
  TDeliverySchedulesImportResponse,
  TGetAllCommissionsParams,
  TUpdateCommissionData,
} from '../utils/types';
import { emptySplitApi } from './emptySplitApi';

export const commissionService = emptySplitApi
  .enhanceEndpoints({
    addTagTypes: ['COMMISSIONS'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getAllCommissions: builder.query<
        { data: TCommission[]; totalCount: number },
        TGetAllCommissionsParams
      >({
        query: (params) => ({
          method: 'GET',
          url: 'product-commissions',
          params: {
            page: params.pageNo,
            size: params.pageSize,
            searchKey: params.searchString
              ? params.searchString
              : null,
            plant: params.plant,
          },
        }),
        transformResponse: (
          data: TCommission[],
          meta: Response
        ) => {
          const totalCount =
            meta.headers.get('X-total-count');
          return {
            data,
            totalCount: Number(totalCount ? totalCount : 0),
          };
        },
        providesTags: ['COMMISSIONS'],
      }),
      commissionImport: builder.mutation<
        TDeliverySchedulesImportResponse,
        { data: FormData; enterpriseId: number }
      >({
        query: ({ data, enterpriseId }) => {
          return {
            url: `product-commissions/import/${enterpriseId}`,
            method: 'POST',
            data,
            headers: createTokenHeader(),
          };
        },
        invalidatesTags: ['COMMISSIONS'],
      }),
      exportCommissions: builder.query<
        { url?: string },
        { enterpriseId: number }
      >({
        query: (data) => {
          return {
            url: 'product-commissions-enterprise/export',
            method: 'POST',
            data,
          };
        },
      }),
      updateCommission: builder.mutation<
        TCommission,
        TUpdateCommissionData
      >({
        query: (data) => {
          return {
            url: 'product-commissions',
            method: 'PUT',
            data,
          };
        },
        invalidatesTags: ['COMMISSIONS'],
      }),
      getCommissionById: builder.query<TCommission, string>(
        {
          query: (commissionId) => {
            return {
              url: `product-commissions/${commissionId}`,
              method: 'GET',
            };
          },
        }
      ),
    }),
  });

export const {
  useGetAllCommissionsQuery,
  useCommissionImportMutation,
  useLazyExportCommissionsQuery,
  useUpdateCommissionMutation,
  useGetCommissionByIdQuery,
} = commissionService;
